import { inject, isDevMode } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppRole } from '@core/models/permission.model';
import { RoleService } from '@core/services/role.service';

export function roleGuard(requiredRoles: AppRole[]): CanActivateFn {
  return (route, state) => {
    const roleService = inject(RoleService);
    const router = inject(Router);

    return roleService.hasRole(requiredRoles).pipe(
      map(hasAccess => {
        if (!hasAccess) {
          if (isDevMode()) {
            console.warn(`[RoleGuard] Access denied for route ${state.url}. Required roles: ${requiredRoles.join(', ')}`);
          }
          router.navigate(['/unauthorized']);
          return false;
        }
        return true;
      }),
      catchError(() => {
        router.navigate(['/unauthorized']);
        return of(false);
      })
    );
  };
}
